module.exports = __webpack_public_path__ + "382c57748f88c4c34e88eb218829e03d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/balloon-s.png
// module id = 2480
// module chunks = 0